import { ContactDetails } from '@mobi/api-types'

export function isInternationalCustomer(
  residentialAddress?: ContactDetails['ResidentialAddress']
): boolean {
  return Boolean(
    residentialAddress?.Country &&
      residentialAddress.Country.length > 0 &&
      residentialAddress.Country?.toLowerCase() !== 'australia'
  )
}
